import { render, staticRenderFns } from "./SystemConfigAgentKefu.vue?vue&type=template&id=a07fe44a&"
import script from "./SystemConfigAgentKefu.vue?vue&type=script&lang=js&"
export * from "./SystemConfigAgentKefu.vue?vue&type=script&lang=js&"
import style0 from "./SystemConfigAgentKefu.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports